import { DeviceIds, DeviceRoles } from '@vi-iot/client/models';
import moment from 'moment';
import { RichDevice } from '../devices';
import {
  PowerLimitation,
  PowerLimitationControllableDeviceName,
  PowerLimitationTableList,
} from './power-limitation-history.model';

export namespace PowerLimitationHistoryHelper {
  export function mapPowerLimitationResponse(
    powerLimitationResponse: PowerLimitation[],
    devicesOfSelectedGateway: RichDevice[],
    deviceIds: string[],
    format: string
  ): PowerLimitationTableList[] {
    const controllableDeviceNameMap: { [key: string]: string } = {};
    const filteredDevices = devicesOfSelectedGateway.filter((item) =>
      deviceIds.some((id) => id.toLowerCase() === item.id.toLowerCase())
    );

    filteredDevices.forEach((device) => {
      if (device.id === DeviceIds.Hems) {
        controllableDeviceNameMap[device.id] = PowerLimitationControllableDeviceName.Hems;
      } else if (device.roles.includes(DeviceRoles.VCS)) {
        controllableDeviceNameMap[device.id] =
          PowerLimitationControllableDeviceName.VehicleChargingStation;
      } else {
        controllableDeviceNameMap[device.id] = `${device.shortDeviceName} (${device.boilerSerial})`;
      }
    });

    return powerLimitationResponse.map((item) => {
      const startDateTime = moment.parseZone(item.start_datetime);
      const endDateTime = moment.parseZone(item.end_datetime);

      let deviceName = controllableDeviceNameMap[item.device_id];
      if (!deviceName) {
        switch (item.device_id) {
          case DeviceIds.Hems:
            deviceName = PowerLimitationControllableDeviceName.Hems;
            break;
          case DeviceIds.Eebus1:
            deviceName = PowerLimitationControllableDeviceName.VehicleChargingStation;
            break;
          default:
            deviceName = item.device_id;
            break;
        }
      }

      const powerLimitationTableList: PowerLimitationTableList = {
        startDate: startDateTime.format(format),
        startTime: startDateTime.format('HH:mm'),
        endDate: endDateTime.format(format),
        endTime: endDateTime.format('HH:mm'),
        controllableDevice: deviceName,
        controlCommand: item.control_command,
        limitationValue: `${item.limitation} ${item.unit}`,
      };

      return powerLimitationTableList;
    });
  }
}
